import { LOGIN_PATH, navigate } from '../lib/navigation';
import api from './api-service';
import { User, Tenant } from '@turizi/shared';

export const isAuthenticated = (): boolean => {
    return localUser() !== null;
};

export const localUser = (): User | null => {
    try {
        return localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user') as string) as User : null;
    } catch (error) {
        return null;
    }
};

export const localTenant = (): Tenant | null => {
    try {
        return localStorage.getItem('tenant') ? JSON.parse(localStorage.getItem('tenant') as string) as Tenant : null;
    } catch (error) {
        return null;
    }
};

export const logout = async (email?: string): Promise<void> => {
    if (isAuthenticated()) {
        localStorage.removeItem('user');
        localStorage.removeItem('tenant');
        api.auth.logout();
    }
    navigate(LOGIN_PATH + (email ? `?email=${email}` : ''));
};

export const login = async (email: string): Promise<any> => {
    const { data, error } = await api.auth.login({ email });
    if (error) {
        throw new Error(error.message || 'login_failed');
    }
    return data;
};

export const loginWithPassword = async (email: string, password: string): Promise<any> => {
    const { data, error } = await api.auth.loginPassword({ email, password });
    if (error) {
        throw new Error(error.message || 'login_failed');
    }
    localStorage.setItem('user', JSON.stringify(data.user));
    localStorage.setItem('tenant', JSON.stringify(data.tenant));
    return data;
};

export const validateMagicToken = async (token: string): Promise<void> => {
    const { data, error } = await api.auth.validateToken(token);
    if (error) {
        throw new Error(error.message || 'Token validation failed');
    }
    localStorage.setItem('user', JSON.stringify(data.user));
    localStorage.setItem('tenant', JSON.stringify(data.tenant));
};

export const updateMe = async (force: boolean = false): Promise<void> => {
    try {
        const lastUpdateKey = 'user_last_update';
        const lastUpdate = localStorage.getItem(lastUpdateKey);
        const now = Date.now();
        const thirtyMinutes = 30 * 60 * 1000;

        const user = localUser();

        // Execute update if: user is null OR time since last update >= 30 min OR force is true
        const shouldUpdate = !user?.id || !lastUpdate || now - parseInt(lastUpdate, 10) >= thirtyMinutes || force;

        if (!shouldUpdate) {
            return;
        }

        const { data, error } = await api.auth.me();

        if (error || !data) {
            return;
        }

        localStorage.setItem('user', JSON.stringify(data.user));
        localStorage.setItem('tenant', JSON.stringify(data.user.tenant));
        localStorage.setItem(lastUpdateKey, now.toString());

    } catch (error) {
        console.log('Error updating user info', error);
    }
};
